import React, { /* useMemo */ } from "react";
import './ProductsContainer.css';
import { useSelector } from "react-redux";
import ProductCard from "../ProductCard/ProductCard";
// import Utils from "../../utils/Utils"

const ProductsContainer = () => {
  const products = useSelector(state => state.products);
  const prevProducts = useSelector(state => state.prevProducts);
  // const promotions = useSelector(state => state.config.promotions.card);
  // const shopId = useSelector(state => state.config.shopId);
  // const baseUrl = useSelector(state => state.config.baseUrl);
  // const isMobile = useSelector(state => state.isMobile);
  // const searchWord = useSelector(state => state.searchWord);
  // const activeFilters = useSelector(state => state.activeFilters);
  const imgPrefix = useSelector(state=>state.imgPrefix)

  // const reactivePromotions=useMemo(()=> isMobile?promotions.mobile:promotions.desktop,[promotions,isMobile] );

  return(
    <div className="products-container" >
      {/* {reactivePromotions.values.map((promo,index)=>
        {return reactivePromotions.isActive && Utils.checkPromotionConditions(promo.conditions,searchWord,activeFilters)?
          <div className="product-card promo" key={"promo_card"+index} onClick={()=> 
            Utils.sendAnalyticsObject(baseUrl,shopId,"as_click_promotion",{id:index,type:"card",device:(isMobile?"mobile":"desktop")}) }> 
            <a href={promo.url}> <img src={promo.img} alt={promo.img} /> </a> 
          </div>:null})} */}
      {products.filter((el)=>typeof(el.value)!='function').map((el,index) => el && el.data?<ProductCard value = {el} index={index} key={'product_'+index} id={'accelasearch_product_'+(index+1)} prevValue={prevProducts[index]} imgPrefix={imgPrefix} />:null )}
    </div>
  )
};

export default ProductsContainer;